import { type ReactNode, useState } from 'react';
import { registrarEvento } from '../lib/api';
import { linkConvite } from '../lib/basePath';
import { mensagemIndicacao } from '../lib/mensagem';
import { Botao } from './ui';
import { GlifoWhatsApp } from './icones';
import { FolhaCompartilhar } from './FolhaCompartilhar';

/**
 * `BotaoIndicar` (DESIGN-FOUNDATION §6.3) — CTA vermelho `--acento` de 56px,
 * glifo do WhatsApp branco (não verde, §5.5), largura total. É onde o funil mais
 * vaza (UX §5.3): `navigator.share` primeiro; sem ele (ou em erro) abre a folha
 * de fallback com a mensagem **pré-escrita e editável**.
 */
export function BotaoIndicar({
  codigo,
  brindeIndicado,
}: {
  codigo: string;
  brindeIndicado: string | null;
}): ReactNode {
  const [folha, setFolha] = useState(false);
  const mensagem = mensagemIndicacao(codigo, brindeIndicado);
  const url = linkConvite(codigo);

  const abrirFallback = (): void => {
    void registrarEvento('share_fallback');
    setFolha(true);
  };

  const compartilhar = async (): Promise<void> => {
    void registrarEvento('share_iniciado');
    if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
      try {
        await navigator.share({ text: mensagem, url });
      } catch (err) {
        // cancelar não é erro (§6.3): só abre o fallback em falha real
        if (err instanceof DOMException && err.name === 'AbortError') return;
        abrirFallback();
      }
      return;
    }
    abrirFallback();
  };

  return (
    <div className="flex flex-col gap-3">
      <Botao variante="primario" onClick={() => void compartilhar()}>
        <GlifoWhatsApp />
        Indicar pelo WhatsApp
      </Botao>
      {folha && (
        <FolhaCompartilhar
          codigo={codigo}
          mensagemInicial={mensagem}
          aoFechar={() => setFolha(false)}
        />
      )}
    </div>
  );
}
